module.exports = __webpack_public_path__ + "static/media/delete-ic.9c80a9d1.svg";